import { apiService, getController } from '@/services/service'

const url = 'person_access_rejections'

export const personAccessRejectionService = {
	...getController<Api.PersonAccessRejection>(url),
	release: (id: number) =>
		apiService.post<Api.PersonAccessRejection>({
			url: `${url}/${id}/release`,
		}),
}

export default personAccessRejectionService
